// Problems raised on the floor (L4): build, step, photo, status in Manufacturing, and the holds waiting on each.
import { Link } from 'react-router';

import { useProblems } from '../../api/queries';
import { Badge, EmptyState, ErrorPanel, Loading, PageHeader } from '../../design/components';
import { formatDateTime } from '../../design/format';

const STATUS_TONE = { Open: 'pending', Resolved: 'success', Unknown: 'neutral' } as const;

export function ProblemsPage() {
    const problems = useProblems();
    return (
        <section className="sf-stack" aria-labelledby="problems-heading">
            <PageHeader id="problems-heading" title="Problems raised on the floor" />
            {problems.isPending ? <Loading what="the problems" /> : null}
            {problems.isError ? <ErrorPanel error={problems.error} /> : null}
            {problems.data?.length === 0 ? <EmptyState>No problems raised. Good.</EmptyState> : null}
            {problems.data && problems.data.length > 0 ? (
                <table className="sf-table">
                    <thead>
                        <tr>
                            <th scope="col">Raised</th>
                            <th scope="col">Build</th>
                            <th scope="col">Where</th>
                            <th scope="col">Part and note</th>
                            <th scope="col">Status</th>
                            <th scope="col">Photo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {problems.data.map(
                            ({ problem, buildId, assemblyPartNumber, station, stepTitle, holdsWaiting, photoUrl }) => (
                                <tr key={problem.buildIssueId}>
                                    <td>
                                        {formatDateTime(problem.raised.at)}
                                        <div className="sf-muted">{problem.raised.displayName}</div>
                                    </td>
                                    <td>
                                        <Link to={`/lead/builds/${buildId}`} className="sf-mono">
                                            {assemblyPartNumber}
                                        </Link>
                                        <div className="sf-muted">{station}</div>
                                    </td>
                                    <td>
                                        {problem.step === null
                                            ? problem.kitLine === null
                                                ? 'Build'
                                                : `Kit line ${String(problem.kitLine)}`
                                            : `Step ${String(problem.step)}`}
                                        {stepTitle ? <div className="sf-muted">{stepTitle}</div> : null}
                                    </td>
                                    <td>
                                        <strong className="sf-mono">{problem.partNumber}</strong> {problem.note}
                                    </td>
                                    <td>
                                        <Badge tone={STATUS_TONE[problem.status]}>{problem.status}</Badge>
                                        {holdsWaiting > 0 ? (
                                            <div className="sf-muted">{holdsWaiting} hold(s) waiting</div>
                                        ) : null}
                                    </td>
                                    <td>
                                        {photoUrl ? (
                                            <img
                                                src={photoUrl}
                                                alt={`${problem.partNumber} as raised`}
                                                style={{ maxHeight: 80 }}
                                            />
                                        ) : (
                                            '—'
                                        )}
                                    </td>
                                </tr>
                            ),
                        )}
                    </tbody>
                </table>
            ) : null}
        </section>
    );
}
